import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { esTranslations, enTranslations } from './translations';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLangSubject = new BehaviorSubject<string>('es');
  public currentLang$: Observable<string> = this.currentLangSubject.asObservable();

  private availableLanguages = [
    { code: 'es', name: 'Español' },
    { code: 'en', name: 'English' }
  ];

  constructor(private translate: TranslateService) {
    this.initLanguage();
  }

  private initLanguage(): void {
    const savedLang = localStorage.getItem('selectedLanguage') || 'es';

    // Set translations directly
    this.translate.setTranslation('es', esTranslations);
    this.translate.setTranslation('en', enTranslations);

    this.translate.addLangs(['es', 'en']);
    this.translate.setDefaultLang('es');

    this.setLanguage(savedLang);
  }

  setLanguage(lang: string): void {
    this.translate.use(lang);
    this.currentLangSubject.next(lang);
    localStorage.setItem('selectedLanguage', lang);

    document.documentElement.lang = lang;
  }

  getCurrentLanguage(): string {
    return this.currentLangSubject.value;
  }

  getAvailableLanguages() {
    return this.availableLanguages;
  }

  toggleLanguage(): void {
    const currentLang = this.getCurrentLanguage();
    const newLang = currentLang === 'es' ? 'en' : 'es';
    this.setLanguage(newLang);
  }
}